module.exports = __webpack_public_path__ + "static/media/CircularPro-Bold.40005560.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-Bold.otf
// module id = 109
// module chunks = 0